<template>
  <div v-if="availableCertifications.length > 0" class="certifications-list">
    <h1 class="certifications-list__title">Certifications</h1>
    <template v-if="isTeamsView">
      <div class="certifications-list__intro">
        Interested in INE certification vouchers for your team?
        <a href="mailto:sales@ine.com" class="certifications-list__link">Contact our sales team</a>
        to get started.
      </div>
    </template>
    <template v-else>
      <div class="certifications-list__intro">
        Demonstrate mastery by acing one of these industry leading certifications, and take your
        career to the next level.
      </div>
      <div class="certifications-list__items">
        <CertificationListItem
          v-for="certification in availableCertifications"
          :key="certification.merchant_id"
          :certification="certification"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CertificationListItem from '@/components/certifications/CertificationListItem.vue'

export default {
  name: 'CertificationsList',
  components: { CertificationListItem },
  computed: {
    ...mapGetters({
      availableCertifications: 'products/availableCertifications',
      isTeamsView: 'app/isB2BOfferView',
    }),
  },
}
</script>

<style lang="scss" scoped>
.certifications-list {
  &__title {
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 700;
    margin-bottom: 30px;
  }
  &__intro {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 30px;
  }
  &__items {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(1, 1fr);
    @include mobile {
      grid-template-columns: repeat(2, minmax(226px, 1fr));
    }
    @include tablet-ipad-air-and-mini-portrait {
      grid-template-columns: repeat(1, minmax(226px, 1fr));
    }
    @include tablet-ipad-pro {
      grid-template-columns: repeat(2, minmax(226px, 1fr));
    }
    @include desktop {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  &__link {
    color: var(--purple-pale);
    text-decoration: none;
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 30px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
